import { render, staticRenderFns } from "./ModattaStepInteractionQrCode.vue?vue&type=template&id=8a1eccf2"
import script from "./ModattaStepInteractionQrCode.vue?vue&type=script&lang=js"
export * from "./ModattaStepInteractionQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports